import { ButtonType, ButtonWidget, FlyoutListMenuWidget, MenuButtonWidget } from '@tableau/widgets';
import React = require('react');
import { ScheduleLinkedTask, ScheduleSingleFlowTask } from '~src/app/actions/AppActionTypes';
import { Messages } from '~src/codegen/Localize';
import { cssClass } from '~src/style';

import { FlowDetailWithUsageInfo } from '../models/FlowInfo';
import { openCreateFlowRunTaskDialog } from '../utils/FlowDialogUtils';

const menuButtonStyle = cssClass('NewTask', 'menu-button', {
  minWidth: '24px !important',
  maxWidth: '24px !important',
  marginLeft: 1,
  $nest: {
    '&::after': {
      marginRight: '2px !important',
    }
  }
});

export const CreateTaskMenuDropdownButton = (flowDetailInfo: FlowDetailWithUsageInfo) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);
  const menuId = 'new-task-button-menu-id';

  const handleSelect = React.useCallback(value => {
    switch (value) {
      case ScheduleSingleFlowTask:
        openCreateFlowRunTaskDialog(flowDetailInfo);
        break;
      case ScheduleLinkedTask:
        openCreateFlowRunTaskDialog(flowDetailInfo, undefined, true);
        break;
    }
    setIsOpen(false);
  }, [flowDetailInfo]);
  return (
    <>
      <MenuButtonWidget
        aria-controls={menuId}
        isOpen={isOpen}
        onClick={() => setIsOpen(!isOpen)}
        ref={setAnchorEl}
        testId={'new-task-button-id'}
        kind={'primary'}
        className={menuButtonStyle}
      />
      {isOpen &&
        <FlyoutListMenuWidget
          anchorEl={anchorEl!}
          allowAutoPosition={true}
          id={menuId}
          menuItemInfos={[
            { displayValue: Messages.scheduleSingleTaskAction(), value: ScheduleSingleFlowTask },
            { displayValue: Messages.scheduleLinkedTaskAction(), value: ScheduleLinkedTask },
          ]}
          onSelect={handleSelect}
          requestCloseAll={() => setIsOpen(false)}
          menuStyle={{ minWidth: anchorEl!.getBoundingClientRect().width }}
          subMenuAllowAutoPosition={true}
          testId={menuId}
          toggleEl={anchorEl!}
        />
      }
    </>
  );
};

export const newTaskButton = (flowDetailInfo: FlowDetailWithUsageInfo, showLinkedTasks: boolean): JSX.Element => {
  return (
    <ButtonWidget
      handleClick={() => openCreateFlowRunTaskDialog(flowDetailInfo)}
      buttonType={showLinkedTasks ? ButtonType.Primary : ButtonType.Outline}
      testId={'ScheduledTaskCreateRunFlowTaskTestId'}
    >
      {Messages.newTask()}
    </ButtonWidget>);
};